module.exports = __webpack_public_path__ + "static/media/2.fee6eb57.jpeg";